// extracted by css-extract-rspack-plugin
export default {"taskPriorityCellRoot":"TaskPriorityCell_taskPriorityCellRoot__-LkX1"};